module.exports = __webpack_public_path__ + "static/media/18.7d150029.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/18.png
// module id = 1456
// module chunks = 0